import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 5 23",
  class: "jl2-sidebar-secondary-icon"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "currentColor",
      class: "content"
    }, [
      _createElementVNode("path", { d: "M2.79 4.54C1.72 4.54.85 3.67.85 2.6c0-1.07.87-1.94 1.94-1.94 1.07 0 1.94.87 1.94 1.94 0 1.07-.87 1.94-1.94 1.94ZM2.79 22.66c-1.07 0-1.94-.87-1.94-1.94 0-1.07.87-1.94 1.94-1.94 1.07 0 1.94.87 1.94 1.94 0 1.07-.87 1.94-1.94 1.94ZM2.79 13.6c-1.07 0-1.94-.87-1.94-1.94 0-1.07.87-1.94 1.94-1.94 1.07 0 1.94.87 1.94 1.94 0 1.07-.87 1.94-1.94 1.94Z" })
    ], -1)
  ])))
}